module.exports = __webpack_public_path__ + "static/media/0.2bd5a461.gif";